import axios from 'axios';
import { createSlice } from '@reduxjs/toolkit';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: true,
  error: false,
  messagesList: [],
  messagesListNew: {
      list: [],
      count: 0
  },
  messageData: []
};

const slice = createSlice({
  name: 'list',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET MANAGE Messages
    getMessagesListSuccessNew(state, action) {
      state.isLoading = false;
      state.messagesListNew = action.payload;
    },
    getMessagesListSuccess(state, action) {
      state.isLoading = false;
      state.messagesList = action.payload;
    },
    getMessageSuccess(state, action) {
      state.isLoading = false;
      state.messageData = action.payload;
    },
  }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getMessagesList() {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.get('https://api.asystent.biz/api/messages');

            dispatch(slice.actions.getMessagesListSuccess(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getMessagesUserList(id) {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.get('https://api.asystent.biz/api/messages-user/'+id);
            let newAs = await getMessagesUserListNewAsync(id);
            dispatch(slice.actions.getMessagesListSuccessNew(newAs));

            dispatch(slice.actions.getMessagesListSuccess(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getMessagesUserListNew(id) {
    return async (dispatch) => {
        console.log("work???")
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.get('https://api.asystent.biz/api/messages-user-new/'+id);

            dispatch(slice.actions.getMessagesListSuccessNew(response.data));
        } catch (error) {
            console.log(slice.actions.hasError(error));
        }
    }
}
export async function getMessagesUserListNewAsync(id) {
    try {
        const response = await axios.get('https://api.asystent.biz/api/messages-user-new/'+id);

        return response.data
    } catch (error) {
        console.log(error);
    }
}

export function getMessage(id) {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.get('https://api.asystent.biz/api/messages-view/'+id);

            dispatch(slice.actions.getMessageSuccess(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getMessageUser(id,uid) {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.get('https://api.asystent.biz/api/messages-user-view/'+id);
            if(uid!=false) {
                let newAs = await getMessagesUserListNewAsync(uid);
                dispatch(slice.actions.getMessagesListSuccessNew(newAs));
            }
            
            dispatch(slice.actions.getMessageSuccess(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function deleteMessage(id) {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.get('https://api.asystent.biz/api/messages-dell/'+id);
            
            dispatch(slice.actions.getMessagesListSuccess(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function deleteUserMessage(id) {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.get('https://api.asystent.biz/api/messages-mdell/'+id);
            
            dispatch(slice.actions.getMessagesListSuccess(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function deleteUserMessageTwo(id,user) {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            await axios.get('https://api.asystent.biz/api/messages-mdell/'+id);
            const response = await axios.get('https://api.asystent.biz/api/messages-user/'+user);

            dispatch(slice.actions.getMessagesListSuccess(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export async function saveMessage(data) {
    try {
        let result = await axios.post('https://api.asystent.biz/api/messages-new', data);

        return result.data
    } catch (error) {
        dispatch(slice.actions.hasError(error));
    }
}

export async function addUsersInMessage(id,items) {
    let data = {id:id, items:items}

    try {
        let result = await axios.post('https://api.asystent.biz/api/messages-add-users', data);

        return result.data
    } catch (error) {
        dispatch(slice.actions.hasError(error));
    }
}